import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'
import css from './AceptacionCondiciones.module.css'

const AceptacionCondiciones = ({ 
  aceptaCondiciones, 
  aceptaProteccionDatos, 
  setAceptaCondiciones, 
  setAceptaProteccionDatos 
})=> (
  <FormGroup className={css.group}>
    <FormControlLabel
      className={css.checkbox} 
      required 
      disabled={aceptaCondiciones && aceptaProteccionDatos}
      control={<Checkbox checked={aceptaCondiciones} onChange={e => setAceptaCondiciones(e.target.checked)} />}
      label="He leído, entiendo y acepto las condiciones de contratación" 
    />
    <FormControlLabel
      className={css.checkbox} 
      required 
      disabled={aceptaCondiciones && aceptaProteccionDatos}
      control={<Checkbox checked={aceptaProteccionDatos} onChange={e => setAceptaProteccionDatos(e.target.checked)} />}
      label="He leído, entiendo y acepto el tratamiento de datos de mundoestudiante" 
    />
  </FormGroup>
)

export default AceptacionCondiciones